import React from 'react';

export default class AskButton extends React.Component {

	constructor(props) {
		super(props)

	}


	render() {
		return (
			<button className="ask-button">提问</button>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/nav/askQuestionButton.js
 **/